import { render, staticRenderFns } from "./searchInsure.vue?vue&type=template&id=036e3ef1&scoped=true"
import script from "./searchInsure.vue?vue&type=script&lang=js"
export * from "./searchInsure.vue?vue&type=script&lang=js"
import style0 from "./searchInsure.vue?vue&type=style&index=0&id=036e3ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e3ef1",
  null
  
)

export default component.exports